import * as Sharing from 'expo-sharing';

// https://docs.expo.io/versions/latest/sdk/sharing/
const shareImage = async (
	uri: string,
	dialogTitle = 'Share',
	mimeType = 'image/png',
): Promise<boolean> => {
	try {
		const isAvailable = await Sharing.isAvailableAsync();
		if (!isAvailable) return false;
		await Sharing.shareAsync(uri, {
			dialogTitle,
			mimeType,
		});
		console.info(uri);
		return true;
	} catch (error) {
		console.warn(error);
		return false;
	}
};

export default shareImage;
